import { BOOK_TYPE } from "./book-data";

const BOOK_CONFIG = {
  currentBookType: BOOK_TYPE.SICP,
  openAnimation: {
    duration: 450,
    sideCoverOffset: 0.04,
    backCoverOffset: 0.009,
  },
  page: {
    width: 950,
    height: 1370,
    resolution: 0.6,
    flipDuration: 650,
  },
  books: {
    [BOOK_TYPE.SICP]: {
      fileName: 'ricvasquez-notebook.pdf',
      // bump whenever the notebook PDF content changes (cache-busts the PDF.js fetch)
      version: '20260912b',
      name: ' long money ',
    },
    [BOOK_TYPE.Algorithms]: {
      fileName: 'algorithms.pdf',
      name: ' Algorithms - 4th Edition ',
    },
  }
}

export { BOOK_CONFIG };
